import { TEditDishAction, EditDishActionTypes } from './editDishActions';
import { IEditDishState } from './editDishContext';

export const editDishReducer = (state: IEditDishState, action: TEditDishAction): IEditDishState => {
	switch (action.type) {
		case EditDishActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditDishActionTypes.SET_ALL_DATA:
			return {
				...state,
				dishID: action.payload.dishID,
				type: action.payload.type,
				isCreatedOnPos: action.payload.isCreatedOnPos,
				filePath: action.payload.filePath,
				nameOfDish: action.payload.nameOfDish,
				description: action.payload.description,
				initialIDSelectedCustomer: action.payload.initialIDSelectedCustomer,
				posName: action.payload.posName,
				externalId: action.payload.externalId,
				articleNumber: action.payload.articleNumber,
				initialIDsSelectedRestaurant: action.payload.initialIDsSelectedRestaurant,
				hasSchedulePriority: action.payload.hasSchedulePriority,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				translations: action.payload.translations,
				fetchedSuggestedDishes: action.payload.fetchedSuggestedDishes,
				selectedSuggestedDishes: action.payload.selectedSuggestedDishes,
				fetchedAdditionalDishes: action.payload.fetchedAdditionalDishes,
				selectedAdditionalDishes: action.payload.selectedAdditionalDishes,
				fetchedModificationDishes: action.payload.fetchedModificationDishes,
				selectedModificationDishes: action.payload.selectedModificationDishes,
			};
		case EditDishActionTypes.CHANGE_LOADER_STATUS:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case EditDishActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case EditDishActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
			};
		case EditDishActionTypes.CHANGE_NAME_OF_DISH:
			return {
				...state,
				nameOfDish: action.payload.nameOfDish,
			};
		case EditDishActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case EditDishActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case EditDishActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
			};
		case EditDishActionTypes.CHANGE_POS_NAME:
			return {
				...state,
				posName: action.payload.posName,
			};
		case EditDishActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case EditDishActionTypes.CHANGE_ARTICLE_NUMBER:
			return {
				...state,
				articleNumber: action.payload.articleNumber,
			};
		case EditDishActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditDishActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditDishActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditDishActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY:
			return {
				...state,
				hasSchedulePriority: !state.hasSchedulePriority,
			};
		case EditDishActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditDishActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditDishActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditDishActionTypes.SET_INITIAL_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case EditDishActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedModificationDishCategory: null,
				fetchedModificationDishSubCategories: [],
				selectedModificationDishSubCategory: null,
				fetchedModificationDishes: [],
				selectedModificationDishes: [],
			};
		case EditDishActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.fetchedCategories,
			};
		case EditDishActionTypes.SET_SUGGESTED_DISH_CATEGORY:
			return {
				...state,
				selectedSuggestedDishCategory: action.payload.selectedSuggestedDishCategory,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
			};
		case EditDishActionTypes.SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedSuggestedDishSubCategories: action.payload.fetchedSuggestedDishSubCategories,
			};
		case EditDishActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedSuggestedDishSubCategory: action.payload.selectedSuggestedDishSubCategory,
			};
		case EditDishActionTypes.SET_FETCHED_SUGGESTED_DISHES:
			return {
				...state,
				fetchedSuggestedDishes: action.payload.fetchedSuggestedDishes,
			};
		case EditDishActionTypes.SET_SUGGESTED_DISHES:
			return {
				...state,
				selectedSuggestedDishes: action.payload.selectedSuggestedDishes,
			};
		case EditDishActionTypes.SET_ADDITIONAL_DISH_CATEGORY:
			return {
				...state,
				selectedAdditionalDishCategory: action.payload.selectedAdditionalDishCategory,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
			};
		case EditDishActionTypes.SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedAdditionalDishSubCategories: action.payload.fetchedAdditionalDishSubCategories,
			};
		case EditDishActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedAdditionalDishSubCategory: action.payload.selectedAdditionalDishSubCategory,
			};
		case EditDishActionTypes.SET_FETCHED_ADDITIONAL_DISHES:
			return {
				...state,
				fetchedAdditionalDishes: action.payload.fetchedAdditionalDishes,
			};
		case EditDishActionTypes.SET_ADDITIONAL_DISHES:
			return {
				...state,
				selectedAdditionalDishes: action.payload.selectedAdditionalDishes,
			};
		case EditDishActionTypes.SET_MODIFICATION_DISH_CATEGORY:
			return {
				...state,
				selectedModificationDishCategory: action.payload.selectedModificationDishCategory,
				fetchedModificationDishSubCategories: [],
				selectedModificationDishSubCategory: null,
			};
		case EditDishActionTypes.SET_FETCHED_MODIFICATION_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedModificationDishSubCategories: action.payload.fetchedModificationDishSubCategories,
			};
		case EditDishActionTypes.SET_MODIFICATION_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedModificationDishSubCategory: action.payload.selectedModificationDishSubCategory,
			};
		case EditDishActionTypes.SET_FETCHED_MODIFICATION_DISHES:
			return {
				...state,
				fetchedModificationDishes: action.payload.fetchedModificationDishes,
			};
		case EditDishActionTypes.SET_MODIFICATION_DISHES:
			return {
				...state,
				selectedModificationDishes: action.payload.selectedModificationDishes,
			};
		case EditDishActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
